import React from 'react';
import './thinking-animation.scss';
import ThinkingDisplay from './ThinkingDisplay';

interface ThinkingAnimationProps {
  showText?: boolean;
  agentNickname?: string;
  agentImageUrl?: string;
  toolDescription?: string;
  visible?: boolean; // If false, renders hidden but keeps img in DOM
  thinkingContent?: string;
}

const ThinkingAnimation: React.FC<ThinkingAnimationProps> = ({
  showText = true,
  agentNickname,
  agentImageUrl,
  toolDescription,
  visible = true,
  thinkingContent,
}) => {
  if (!showText || !agentNickname) {
    return (
      <aside className='dream-thinking'>
        <svg
          xmlns='http://www.w3.org/2000/svg'
          width='16'
          height='17'
          viewBox='0 0 16 17'
          fill='none'
        >
          <path
            d='M0 8.50003C0 8.20548 0.239588 7.96867 0.533408 7.94793C4.232 7.68687 7.18685 4.73201 7.44791 1.03341C7.46865 0.739587 7.70544 0.5 8 0.5C8.29455 0.5 8.53136 0.739587 8.55209 1.03341C8.81316 4.73201 11.768 7.68687 15.4666 7.94793C15.7604 7.96867 16 8.20548 16 8.50003C16 8.79457 15.7604 9.03138 15.4666 9.05212C11.768 9.31318 8.81316 12.268 8.55209 15.9666C8.53136 16.2604 8.29455 16.5 8 16.5C7.70544 16.5 7.46865 16.2604 7.44791 15.9666C7.18685 12.268 4.232 9.31318 0.533408 9.05212C0.239588 9.03138 0 8.79457 0 8.50003Z'
            fill='#374562'
          />
        </svg>
        {showText && <span>Thinking</span>}
      </aside>
    );
  }

  // Display tool description if available, otherwise show "is thinking..."
  const displayText = toolDescription
    ? `${agentNickname} is ${toolDescription}`
    : `${agentNickname} is thinking...`;

  const hiddenStyle = !visible ? { display: 'none' } : undefined;

  return (
    <aside className='dream-longform-thinking' style={hiddenStyle}>
      <div className='name-line'>
        <div className='avatar'>
          {agentImageUrl && <img src={agentImageUrl} />}
        </div>
        <div className='thinking-text-wrapper'>
          <span>{displayText}</span>
          <ThinkingDisplay thinkingContent={thinkingContent || ''} />
        </div>
      </div>
    </aside>
  );
};

export default ThinkingAnimation;
